<div class="modal-header">
  <h3 style="margin-left: 2rem">{{'download_report_modal_title' | translate}}</h3>
  <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" (click)="close()"
       style="margin: 0 0 2rem auto; cursor: pointer">
</div>
<a #exportButtonDownload target="_blank"></a>
<div class="modal-body download-report-body">
  <p style="padding: 3rem 8rem; font-size: 1.6rem">{{'download_report_modal_description' | translate}}</p>
  <div style="padding: 3rem; width: 100%; display: flex; justify-content: space-evenly;">
    <div>
      <p>{{'download_report_modal_start_date' | translate}}</p>
      <p-calendar [(ngModel)]="startDate" [showOnFocus]="true" id="startDatePiker" dateFormat="dd.mm.yy"
                  [showIcon]="true" inputId="icon" icon="bi bi-calendar-plus" appendTo="body"></p-calendar>
    </div>
    <div>
      <p>{{'download_report_modal_end_date' | translate}}</p>
      <p-calendar [(ngModel)]="endDate" [showIcon]="true" dateFormat="dd.mm.yy" inputId="icon"
                  icon="bi bi-calendar-plus" appendTo="body"></p-calendar>
    </div>
  </div>

  <div style="padding: 3rem; width: 100%;">
    <div style="float: right">
      <button
        (click)="canExport ? getModalDate() : ''"
        [pTooltip]="showUpgradeTooltip ? ('download_report_modal_upgrade_tooltip' | translate) : ''"
        tooltipPosition="bottom" tooltipStyleClass="tooltip-style"
        label="{{'download_report_modal_confirm_btn' | translate}}"
        pButton type="button"
        class="btn-blue add-date-button"></button>
      <button class="btn-hallow" style="font-size: 1.2rem" aria-label="Close" (click)="close()">{{'cancel_button' | translate}}
      </button>
    </div>
  </div>
</div>
